import index from './index.vue'

const Advertisement = {
  install: function (Vue) {
    Vue.component('Advertisement', index)
  }
}

export default Advertisement
